import { render, staticRenderFns } from "./xlsx.vue?vue&type=template&id=003acdb3&scoped=true"
import script from "./xlsx.vue?vue&type=script&lang=js"
export * from "./xlsx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003acdb3",
  null
  
)

export default component.exports